import { IAuthLoginResponse } from '../interfaces/auth-login-response.interface';
import { IAuthUser } from '../interfaces/auth-user.interface';
import { ILoginFormModel } from '../interfaces/login-form-model.interface';

export const MOCK_DEMO_CREDENTIALS: ILoginFormModel = {
  email: 'demo@sweetanalytics.com',
  password: 'SweetDemo123!',
};

export const MOCK_DEMO_USER: IAuthUser = {
  id: 'user-demo-001',
  email: 'alex@sweetanalytics.com',
  name: 'Alex Morgan',
};

export const MOCK_DEMO_LOGIN_RESPONSE: IAuthLoginResponse = {
  token: 'session-token',
  sessionId: 'session-1',
  user: {
    id: MOCK_DEMO_USER.id,
    email: MOCK_DEMO_USER.email,
    name: MOCK_DEMO_USER.name,
  },
  clientId: 'client-1',
  activeClientName: 'Acme',
  scopes: [],
  canSwitchClient: false,
};

export const MOCK_SERVER_ERROR_EMAIL = 'error@sweetanalytics.com';

export const MOCK_LOGIN_DELAY_MS = 900;
export const MOCK_REGISTER_DELAY_MS = 900;
export const MOCK_RESET_PASSWORD_DELAY_MS = 900;
